<ng-container *transloco="let t">
  <pxw-modal-dialog
    [title]="t('Sucursales')"
    [headingStyle]="'compact'"
    type="modal"
    [showCloseButton]="true"
  >
    <pxw-icon icon="store" />
    <ng-template #modalContent let-onConfirmAction="onConfirmAction">
      <div class="content-wrapper">
        @if (!userLocation()) {
          <div class="ui-loader ui-loader--with-overlay">
            <pxw-icon icon="loading" [spin]="true" />
          </div>
        } @else {
          <pxw-alert size="xs" type="info" display="inline-block">
            {{ t('subsidiaries.selectorDialogCopy') }}
          </pxw-alert>
          <pxw-stadia-maps
            [center]="userLocation()"
            [zoom]="mapZoom()"
            [geolocationErrorText]="'No pudimos acceder a tu ubicación'"
            (mapLoaded)="onMapLoaded()"
            (geolocationResult)="onGeolocationResult($event)"
          >
            @if (!geolocationResult()) {
              <pxw-button
                class="locate-button"
                size="md"
                color="yellow"
                [rounded]="true"
                [loading]="loadingGeolocation()"
                (click)="$event.stopPropagation(); onDisplayNearestSubsidiaries()"
              >
                <pxw-icon icon="geolocation" />
                {{ t('subsidiaries.listNearbyButton') }}
              </pxw-button>
            }
            @if (displaySubsidiariesGroupSelector()) {
              <pxw-select-box
                class="subsidiary-group-selector"
                [name]="'subsidiaryByGroup'"
                [options]="subsidiariesByGroup()"
                [labelKey]="'groupName'"
                [valueKey]="'key'"
                [(ngModel)]="selectedGroupKey"
              >
                <ng-template #optionItemTemplate let-subsidiaryGroup>
                  <strong>{{ subsidiaryGroup.groupName }}</strong>
                  <br />
                  <span style="color: #999">
                    {{ subsidiaryGroup.subsidiaries.length }}
                    {{ subsidiaryGroup.subsidiaries.length === 1 ? t('tienda') : t('tiendas') }}
                  </span>
                </ng-template>
              </pxw-select-box>
            }
            <ng-template #mapContents>
              @for (subsidiary of subsidiariesByGroupSelected(); track subsidiary.id) {
                <pxw-stadia-maps-marker
                  [lat]="subsidiary.addressDetails.coordinates.lat"
                  [lng]="subsidiary.addressDetails.coordinates.lng"
                  [icon]="mapPinIcon()"
                >
                  <pxw-stadia-maps-popup [maxWidth]="'90%'" [displayClose]="true">
                    <ng-template #popupContent>
                      <app-establishment-info
                        style="min-width: 220px"
                        [establishment]="subsidiary"
                        [displayName]="true"
                        [displayAddress]="true"
                        [displayContactInfo]="true"
                        [displayOpenStatus]="true"
                      />
                      <hr class="ui-separator ui-separator--sm" />
                      <pxw-button
                        size="sm"
                        [rounded]="true"
                        color="yellow"
                        (click)="onConfirmAction(subsidiary.id)"
                      >
                        {{ t('subsidiaries.orderHere') }}
                      </pxw-button>
                    </ng-template>
                  </pxw-stadia-maps-popup>
                </pxw-stadia-maps-marker>
              }
            </ng-template>
          </pxw-stadia-maps>
          @if (geolocationResult()) {
            <div class="nearest-subsidiaries">
              <h4 class="nearest-subsidiaries__title">
                {{ t('subsidiaries.nearbyBranchesTitle') }}
                <pxw-icon
                  icon="close"
                  color="pink"
                  size="xs"
                  (click)="geolocationResult.set(null)"
                />
              </h4>
              @if (nearestSubsidiaries().length > 0) {
                <ul class="nearest-subsidiaries__list">
                  @for (result of nearestSubsidiaries(); track result.subsidiary.id) {
                    @let subsidiary = result.subsidiary;

                    <li class="nearest-subsidiaries__item">
                      <div class="nearest-subsidiaries__item-content">
                        <div class="nearest-subsidiaries__name">{{ subsidiary.name }}</div>
                        <div class="nearest-subsidiaries__address">
                          <pxw-tag size="xs" type="success">{{ result.distance }} KM</pxw-tag>
                          <pxw-icon icon="chevron-right" size="xs" />
                          {{ subsidiary.address || subsidiary.addressDetails?.freeSearch }}
                        </div>
                      </div>
                      <pxw-establishment-opened-status-tag [establishment]="subsidiary" />
                      <pxw-button
                        class="nearest-subsidiaries__order-button"
                        size="sm"
                        color="yellow"
                        [rounded]="true"
                        (click)="onConfirmAction(subsidiary.id)"
                      >
                        {{ t('subsidiaries.orderHere') }}
                      </pxw-button>
                    </li>
                  }
                </ul>
              } @else {
                <pxw-alert
                  size="xs"
                  type="warning"
                  display="inline-block"
                  style="margin-bottom: 1em"
                >
                  {{ t('subsidiaries.noNearbyBranches') }}
                </pxw-alert>
              }
            </div>
          }
        }
      </div>
    </ng-template>
  </pxw-modal-dialog>
</ng-container>
